export default function downloadBlob(blob, filename) {
  const a = document.createElement("a");
  a.download = filename;
  const objectUrl = URL.createObjectURL(blob);
  a.href = objectUrl;
  a.click();
}
